import styled, { css } from 'styled-components';

const verticalStyles = (props) =>
  props?.vertical &&
  css`
    flex-direction: column;
  `;

export default styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  flex-wrap: nowrap;
  overflow-x: scroll;
  white-space: nowrap;
  width: 100%;
  height: 100%;

  ${verticalStyles}
`;
